<template>
  <div class="card custom-card mt-4">
    <div class="container-fluid">
      <div class="table-controls mt-3 d-flex">
        <div class="controls-wrap d-flex w-100">
          <!-- Employer -->
          <select
            class="form-control mr-2"
            @change="handleSelectEmployer($event)"
            v-model="selected"
          >
            <option
              v-for="employer in getEmployersDropdown"
              :key="employer.id"
              :value="{ id: employer.id, name: employer.name }"
            >
              {{ employer.name }}
            </option>
          </select>

          <!-- Job -->
          <select
            v-if="getJobsForEmployer.length"
            class="form-control form-control"
            @change="handleEmployerJobs($event)"
            v-model="selectedJob"
          >
            <option
              v-for="job in getJobsForEmployer"
              :key="job.id"
              :value="{ id: job.id, title: job.title }"
            >
              {{ job.title }}, {{ job.city.name }}
            </option>
          </select>

          <select v-else class="form-control form-control" @change="handleEmployerJobs($event)">
            <option>{{ 'No data' }}</option>
          </select>
        </div>

        <!-- Add btn -->
        <!--   <button
          type="button"
          class="ml-auto btn btn-success text-nowrap d-none d-sm-block"
          @click="showModal = true"
        >
          Add Candidate
          <portal to="add-candidate-modal">
            <CustomMainModal @close="showModal = false" v-show="showModal">
              <template v-slot:header>
                <h5>Add Candidate</h5>
              </template>
              <AddCandidateBtnModal></AddCandidateBtnModal>
            </CustomMainModal>
          </portal>
        </button> -->

        <!--  <button
          type="button"
          class="ml-auto btn btn-success text-nowrap d-block d-sm-none mobile-fixed"
          @click="showModal = true"
        >
          <i class="fas fa-plus-circle"></i>
          <portal to="add-candidate-modal">
            <CustomMainModal @close="showModal = false" v-show="showModal">
              <template v-slot:header>
                <h5>Add Candidate</h5>
              </template>
              <AddCandidateBtnModal></AddCandidateBtnModal>
            </CustomMainModal>
          </portal>
        </button>

        <portal-target name="add-candidate-modal"></portal-target> -->
      </div>

      <div class="groups pipeline d-flex mt-4" style="position: relative">
        <Spinner :isLoading="isLoading" />
        <div class="group">
          <PipelineList headerColor="color-not-contacted" title="NOT CONTACTED">
            <Container
              group-name="1"
              :get-child-payload="getChildPayload1"
              @drop="onDrop('notContactedList', $event, { newStage: 102 })"
            >
              <Draggable v-for="(item, idx) in notContactedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-contacted" title="CONTACTED">
            <Container
              group-name="1"
              :get-child-payload="getChildPayload2"
              @drop="onDrop('contactedList', $event, { newStage: 103 })"
            >
              <Draggable v-for="(item, idx) in contactedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
            <Container
              group-name="1"
              :get-child-payload="getChildPayload3"
              @drop="onDrop('interviewingList', $event, { newStage: 104 })"
            >
              <Draggable v-for="(item, idx) in interviewingList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
            <Container
              group-name="1"
              :get-child-payload="getChildPayload4"
              @drop="onDrop('offeredEmploymentList', $event, { newStage: 106 })"
            >
              <Draggable v-for="(item, idx) in offeredEmploymentList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-employed" title="EMPLOYED">
            <Container
              group-name="1"
              :get-child-payload="getChildPayload4"
              @drop="onDrop('employedList', $event, { newStage: 107 })"
            >
              <Draggable v-for="(item, idx) in employedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
            <Container
              group-name="1"
              :get-child-payload="getChildPayload6"
              @drop="onDrop('noLongerInterestedList', $event, { newStage: 108 })"
            >
              <Draggable v-for="(item, idx) in noLongerInterestedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload7"
              @drop="onDrop('notInConsiderationList', $event, { newStage: 109 })"
            >
              <Draggable v-for="(item, idx) in notInConsiderationList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>
      </div>

      <!--  <div class="no-data-message" v-show="getPipelines.length === '0'">
        <p>No data to display</p>
      </div> -->

      <!-- Mobile accordtion Starts Here -->
      <div class="accordion" id="accordionExample">
        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
            headerColor="color-contacted"
            title="NOT CONTACTED"
            :mobileCounter="notContactedList.length"
          >
            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in notContactedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>
        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
            headerColor="color-not-contacted"
            title="CONTACTED"
            :mobileCounter="contactedList.length"
          >
            <div
              id="collapseTwo"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in contactedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="true"
            aria-controls="collapseThree"
            headerColor="color-interviewing"
            title="INTERVIEWING"
            :mobileCounter="interviewingList.length"
          >
            <div
              id="collapseThree"
              class="collapse"
              aria-labelledby="headingThree"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in interviewingList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>
        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="true"
            aria-controls="collapseFour"
            headerColor="color-offered-employment"
            title="OFFERED EMPLOYMENT"
            :mobileCounter="offeredEmploymentList.length"
          >
            <div
              id="collapseFour"
              class="collapse"
              aria-labelledby="headingFour"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in offeredEmploymentList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>
        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseFive"
            aria-expanded="true"
            aria-controls="collapseFive"
            headerColor="color-employed"
            title="EMPLOYED"
            :mobileCounter="employedList.length"
          >
            <div
              id="collapseFive"
              class="collapse"
              aria-labelledby="headingFive"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in employedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>
        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseSix"
            aria-expanded="true"
            aria-controls="collapseSix"
            headerColor="color-no-longer-interested"
            title="NO LONGER INTERESTED"
            :mobileCounter="noLongerInterestedList.length"
          >
            <div
              id="collapseSix"
              class="collapse"
              aria-labelledby="headingSix"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in noLongerInterestedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>
        <div class="group">
          <PipelineList
            data-toggle="collapse"
            data-target="#collapseSeven"
            aria-expanded="true"
            aria-controls="collapseSeven"
            headerColor="color-not-in-consideration"
            title="NOT IN CONSIDERATION"
            :mobileCounter="notInConsiderationList.length"
          >
            <div
              id="collapseSeven"
              class="collapse"
              aria-labelledby="headingSeven"
              data-parent="#accordionExample"
            >
              <div v-for="(item, idx) in notInConsiderationList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <router-link
                        class="first"
                        style="position: relative"
                        :to="{
                          name: 'candidate_id',
                          params: { candidate_id: item.candidate_id },
                        }"
                      >
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </router-link>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'candidate_id',
                                params: { candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                            <span :title="item.source.description">{{
                              item.source.source_name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </div>
          </PipelineList>
        </div>
      </div>
      <!-- Mobile accordtion ENDS Here -->

      <!-- Tablet slider START -->
      <div
        id="carouselExample-tablet"
        class="carousel slide tablet"
        data-ride="carousel"
        data-wrap="false"
        data-interval="0"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="group">
              <PipelineList headerColor="color-contacted" title="NOT CONTACTED">
                <div v-for="(item, idx) in notContactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-not-contacted" title="CONTACTED">
                <div v-for="(item, idx) in contactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
                <div v-for="(item, idx) in interviewingList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
                <div v-for="(item, idx) in offeredEmploymentList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-employed" title="EMPLOYED">
                <div v-for="(item, idx) in employedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
                <div v-for="(item, idx) in noLongerInterestedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
                <div v-for="(item, idx) in notInConsiderationList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExample-tablet"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExample-tablet"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>

          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- Tablet slider END -->

      <!-- Mid screen slider START -->
      <div
        id="carouselExample-mid"
        class="carousel slide mid-screen"
        data-ride="carousel"
        data-wrap="false"
        data-interval="0"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="group">
              <PipelineList headerColor="color-contacted" title="NOT CONTACTED">
                <div v-for="(item, idx) in notContactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-not-contacted" title="CONTACTED">
                <div v-for="(item, idx) in contactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
                <div v-for="(item, idx) in interviewingList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
                <div v-for="(item, idx) in offeredEmploymentList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-employed" title="EMPLOYED">
                <div v-for="(item, idx) in employedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
                <div v-for="(item, idx) in noLongerInterestedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
                <div v-for="(item, idx) in notInConsiderationList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <router-link
                          class="first"
                          style="position: relative"
                          :to="{
                            name: 'candidate_id',
                            params: { candidate_id: item.candidate_id },
                          }"
                        >
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </router-link>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'candidate_id',
                                  params: { candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span class="mr-2"> {{ countDays(item.created_at) }}</span>
                              <span :title="item.source.description">{{
                                item.source.source_name
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExample-mid"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExample-mid"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>

          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- Tablet slider END -->
    </div>

    <portal to="move-candidate">
      <CustomMainModal @close="onCloseAddJobModal" v-show="showModal" modalSize="modal-xs">
        <template v-slot:header>
          <h5>Employed</h5>
        </template>
        <p v-if="showModal" class="text-center">
          Please confirm that
          <strong
            >{{ temp.dropResult.payload.first_name }}
            {{ temp.dropResult.payload.last_name }}</strong
          >
          should be move to Employed.
        </p>
        <div class="d-flex align-items-center justify-content-center">
          <button
            :disabled="isLoadingPipe"
            @click="confirmMove"
            type="button"
            class="btn btn-secondary me-2"
          >
            Move
          </button>
          <button :disabled="isLoadingPipe" @click="undoMove" type="button" class="btn btn-primary">
            Cancel
          </button>
        </div>
      </CustomMainModal>
    </portal>
    <portal-target name="move-candidate"></portal-target>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Container, Draggable /* , smoothDnD */ } from 'vue-smooth-dnd';
import { applyDrag, listMapper } from '@/utils/helpers';

import PipelineList from '../Pipeline/PipelineList';
import PipelineItem from '../Pipeline/PipelineItem';
import { stagesMixin } from '../../../mixins/stagesMixin';

import CustomMainModal from '../../Modals/CustomMainModal';
import titleMixin from '../../../mixins/titleMixin';

// import { localStorageHelper } from '@/utils/helpers';

/* import format from 'date-fns/format';
import moment from 'moment'; */

export default {
  components: {
    Container,
    Draggable,
    CustomMainModal,
    /*     AddCandidateBtnModal,  */

    PipelineList,
    PipelineItem,
  },
  mixins: [stagesMixin, titleMixin],
  title() {
    return 'Pipelines | Jobshark';
  },
  data: () => ({
    temp: {},
    selected: {},
    selectedJob: {},
    defaultEmployer: {},
    showModal: false,
    baseStyles: {
      backgroundColor: '#333',
    },
    /* DnD */
    notContactedList: [],
    contactedList: [],
    interviewingList: [],
    offeredEmploymentList: [],
    employedList: [],
    noLongerInterestedList: [],
    notInConsiderationList: [],
    getCollection: null,
    /* Snapshot */
    tempNotContactedList: [],
    tempContactedList: [],
    tempInterviewingList: [],
    tempOfferedEmploymentList: [],
    tempEmployedList: [],
    tempNoLongerInterestedList: [],
    tempNotInConsiderationList: [],
    isLoading: false,
    isLoadingPipe: false,
  }),

  methods: {
    ...mapActions([
      'retrieveCandidates',
      'updateDndPipelines',
      'retrieveEmployersDropdown',
      'retrieveJobsForEmployerDropdown',
      'retrieveDndPipelines',
    ]),
    initDndData(data) {
      data.forEach(item => {
        if (item.stage == 102) {
          this.notContactedList.push(item);
        } else if (item.stage == 103) {
          this.contactedList.push(item);
        } else if (item.stage == 104) {
          this.interviewingList.push(item);
        } else if (item.stage == 106) {
          this.offeredEmploymentList.push(item);
        } else if (item.stage == 107) {
          this.employedList.push(item);
        } else if (item.stage == 108) {
          this.noLongerInterestedList.push(item);
        } else if (item.stage == 109) {
          this.notInConsiderationList.push(item);
        }
      });
    },
    countDays(date) {
      const targetDate = new Date(date);
      const currentDate = new Date();
      const timeDifference = currentDate - targetDate;
      const daysPassed = timeDifference / (1000 * 60 * 60 * 24);

      return `${Math.floor(daysPassed)} days`;
    },
    clearDndLists() {
      this.notContactedList = [];
      this.contactedList = [];
      this.interviewingList = [];
      this.offeredEmploymentList = [];
      this.employedList = [];
      this.noLongerInterestedList = [];
      this.notInConsiderationList = [];
    },
    handleEmployerJobs() {
      this.clearDndLists();
      this.isLoading = true;

      this.retrieveDndPipelines({
        id: this.selectedJob.id,
      })
        .then(response => {
          this.isLoading = false;
          this.initDndData(response.data);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleSelectEmployer() {
      this.clearDndLists();

      this.isLoading = true;

      this.retrieveJobsForEmployerDropdown({ employerId: this.selected.id }).then(response => {
        this.isLoading = false;

        this.selectedJob = { id: response.data[0].id, title: response.data[0].title };

        if (response.data.length) {
          this.retrieveDndPipelines({
            id: response.data[0].id,
          })
            .then(response => {
              this.initDndData(response.data);

              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });

      this.isLoading = false;
    },
    onDrag(/* ...params */) {
      (this.tempNotContactedList = this.notContactedList),
        (this.tempContactedList = this.contactedList),
        (this.tempInterviewingList = this.interviewingList),
        (this.tempOfferedEmploymentList = this.offeredEmploymentList),
        (this.tempEmployedList = this.employedList),
        (this.tempNoLongerInterestedList = this.noLongerInterestedList),
        (this.tempNotInConsiderationList = this.notInConsiderationList);
    },
    /* DnD */

    showModalForEmployed(collection, dropResult, stage) {
      this.showModal = true;
      this.temp = {
        collection: collection,
        dropResult: dropResult,
        stage: stage,
      };
    },
    onCloseAddJobModal() {
      this.showModal = false;
      this.showModal = false;
      this.temp = {};
      this.canUpdate = false;
    },

    confirmMove() {
      this.isLoadingPipe = true;
      const { collection, dropResult, stage } = this.temp;
      this.updateDndPipelines({
        pipeline_id: dropResult.payload.id,
        stage: Number(stage.newStage),
      }).then(() => {
        this.isLoadingPipe = false;
        this.showModal = false;
        this.temp = {};
        this.canUpdate = false;
        this.$toasted.show(
          `<div>You have moved <span>${dropResult.payload.first_name} ${
            dropResult.payload.last_name
          }</span> to <span>${listMapper(collection)}</span></div>`,
          {
            position: 'bottom-right',
            singleton: true,
            duration: 7000,
            keepOnHover: true,
            theme: 'toasted-primary',
            action: [
              {
                icon: 'fa-times',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      });
    },

    undoMove() {
      this.showModal = false;
      this.temp = {};
      this.canUpdate = false;
      this.notContactedList = this.tempNotContactedList;
      this.contactedList = this.tempContactedList;
      this.interviewingList = this.tempInterviewingList;
      this.offeredEmploymentList = this.tempOfferedEmploymentList;
      this.employedList = this.tempEmployedList;
      this.noLongerInterestedList = this.tempNoLongerInterestedList;
      this.notInConsiderationList = this.tempNotInConsiderationList;
    },

    onDrop(collection, dropResult, stage) {
      this[collection] = applyDrag(this[collection], dropResult);

      if (dropResult.addedIndex !== null) {
        /*  console.log(
          'id: ',
          dropResult,
          'stage_old: ',
          dropResult.payload.stage,
          'stage_new: ',
          stage.newStage,
        ); */

        if (collection === 'employedList') {
          this.showModalForEmployed(collection, dropResult, stage);
          return false;
        }
        this.updateDndPipelines({
          pipeline_id: dropResult.payload.id,
          stage: Number(stage.newStage),
        });

        this.$toasted.clear();

        this.$toasted.show(
          `<div>You have moved <span>${dropResult.payload.first_name} ${
            dropResult.payload.last_name
          }</span> to <span>${listMapper(collection)}</span></div>`,
          {
            position: 'bottom-right',
            singleton: true,
            duration: 7000,
            keepOnHover: true,
            theme: 'toasted-primary',
            action: [
              {
                text: 'Undo',
                onClick: (e, toastObject) => {
                  this.notContactedList = this.tempNotContactedList;
                  this.contactedList = this.tempContactedList;
                  this.interviewingList = this.tempInterviewingList;
                  this.offeredEmploymentList = this.tempOfferedEmploymentList;
                  this.employedList = this.tempEmployedList;
                  this.noLongerInterestedList = this.tempNoLongerInterestedList;
                  this.notInConsiderationList = this.tempNotInConsiderationList;

                  toastObject.goAway(0);
                },
              },
              {
                icon: 'fa-times',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      }
    },
    getChildPayload1(index) {
      return this.notContactedList[index];
    },
    getChildPayload2(index) {
      return this.contactedList[index];
    },
    getChildPayload3(index) {
      return this.interviewingList[index];
    },
    getChildPayload4(index) {
      return this.offeredEmploymentList[index];
    },
    getChildPayload5(index) {
      return this.employedList[index];
    },
    getChildPayload6(index) {
      return this.noLongerInterestedList[index];
    },
    getChildPayload7(index) {
      return this.notInConsiderationList[index];
    },
  },
  watch: {
    selected() {
      localStorage.pipelineEmployerSelect = JSON.stringify(this.selected);
    },
    selectedJob() {
      localStorage.pipelineSelectedJob = JSON.stringify(this.selectedJob);
    },
  },
  computed: {
    ...mapGetters(['getCandidates', 'getEmployersDropdown', 'getJobsForEmployer', 'getPipelines']),
  },
  mounted() {
    this.isLoading = true;
    this.retrieveEmployersDropdown();

    if (localStorage.pipelineEmployerSelect) {
      this.selected = JSON.parse(localStorage.pipelineEmployerSelect);
    }

    if (localStorage.pipelineSelectedJob) {
      this.selectedJob = JSON.parse(localStorage.pipelineSelectedJob);

      this.retrieveJobsForEmployerDropdown({ employerId: this.selected.id });
    }

    this.retrieveDndPipelines({
      id: this.selectedJob.id,
    })
      .then(response => {
        this.initDndData(response.data);
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.first {
  position: relative;
  background: none !important;
  border: none !important;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}
.pipeline {
  .smooth-dnd-container {
    min-height: calc(100vh - 228px);
  }

  .group {
    flex-shrink: 0;
    width: 14.1%;
    margin-right: 3px;
  }

  .groups {
    position: relative;
  }
  .icons {
    color: #666;
    font-size: 10px;
    margin-top: 5px;
  }
}

/* .card-body:nth-child(even) {
  background-color: red;
} */

.carousel {
  /*  background: red; */
  display: none;
}

.accordion {
  display: none !important;
}

@media only screen and (max-width: 1251px) {
  .card {
    overflow: hidden;
    margin-left: 23px !important;
    margin-right: 23px !important;
  }
  .mid-screen {
    display: block !important;
    .group {
      width: 33%;
      display: inline-block;
    }
  }
  .tablet {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .carousel {
    display: block;
    margin: 20px 2px 15px 0;

    .carousel-item {
      height: calc(100vh - 155px);
      overflow-y: auto;
      .media-body {
        .name {
          font-size: 16px;
        }
        .icons {
          font-size: 14px;
          color: #666;
        }
      }
    }
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      height: 100px;
      width: 100px;
      outline: black;
      background-size: 100%, 100%;
      background-image: none;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
    }
    .carousel-control-prev {
      left: -65px;
    }
    .carousel-control-next {
      right: -65px;
    }

    .carousel-control-next-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f105';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }

    .carousel-control-prev-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f104';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }
  }

  .mobile-fixed {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 54px;
    height: 54px;
    font-size: 28px;
    border-radius: 50%;
    z-index: 9;
    line-height: 34px;
  }

  .pipeline {
    display: none !important;
    padding-bottom: 30px;
    height: calc(100vh - 145px);

    .smooth-dnd-container {
      min-height: calc(100vh - 228px) !important;
    }

    .drag-col {
      width: 100%;
    }

    .card {
      margin-top: 12px !important;
    }
  }

  .controls-wrap {
    width: 100% !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    overflow: hidden;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    overflow: hidden;
  }

  .mid-screen {
    display: none !important;
  }
  .tablet {
    display: block !important;
    .group {
      width: 50%;
      display: inline-block;
    }
  }
  .accordion {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .carousel {
    display: block;
    margin: 20px 2px 15px 0;

    .carousel-item {
      height: calc(100vh - 155px);
      overflow-y: auto;
      .media-body {
        .name {
          font-size: 16px;
        }
        .icons {
          font-size: 14px;
          color: #666;
        }
      }
    }
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      height: 100px;
      width: 100px;
      outline: black;
      background-size: 100%, 100%;
      background-image: none;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
    }
    .carousel-control-prev {
      left: -55px;
    }
    .carousel-control-next {
      right: -55px;
    }

    .carousel-control-next-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f105';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }

    .carousel-control-prev-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f104';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }
  }
  .mobile-fixed {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 54px;
    height: 54px;
    font-size: 28px;
    border-radius: 50%;
    z-index: 9;
    line-height: 34px;
  }
  .pipeline {
    display: none !important;
    padding-bottom: 30px;
    height: calc(100vh - 145px);
    .smooth-dnd-container {
      height: calc(100vh - 228px);
      overflow: hidden;
      overflow-y: auto;
    }
    .drag-col {
      width: 100%;
    }
    .card {
      margin-top: 12px !important;
    }
  }

  .controls-wrap {
    width: 100% !important;
  }
}
@media only screen and (max-width: 576px) {
  .card {
    overflow: hidden;
    overflow-y: auto !important;
  }
  .custom-card {
    height: calc(100vh - 65px) !important;
  }

  .accordion {
    display: block !important;
    margin-top: 20px;
  }

  .mid-screen {
    display: none !important;
  }
  .tablet {
    display: none !important;
  }
  .mobile {
    display: block !important;
  }
  .media-body {
    .name {
      font-size: 16px;
    }
    .icons {
      font-size: 14px;
      color: #666;
    }
  }

  .mobile-fixed {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 54px;
    height: 54px;
    font-size: 28px;
    border-radius: 50%;
    z-index: 9;
    line-height: 34px;
  }
  .pipeline {
    display: none !important;
    padding-bottom: 30px;
    height: calc(100vh - 145px);
    .smooth-dnd-container {
      height: calc(100vh - 228px);
      overflow: hidden;
      overflow-y: auto;
    }
    .drag-col {
      width: 100%;
    }
    .card {
      margin-top: 12px !important;
    }
  }

  .controls-wrap {
    width: 100% !important;
  }
}
</style>
